import { useState } from "react";

import { FLAG_LENGTH_LIMIT } from "../consts";

const useInvalidationControls = () => {
  const [invalidationReason, setInvalidationReason] = useState("");
  const [isShowToParticipant, setShowToParticipant] = useState(false);
  const isReasonTooLong = invalidationReason.length > FLAG_LENGTH_LIMIT;
  const characterLimitText = `${invalidationReason.length.toLocaleString()}/${FLAG_LENGTH_LIMIT.toLocaleString()}`;
  const isReasonIncorrect = !invalidationReason || isReasonTooLong;

  return {
    invalidationReason,
    setInvalidationReason,
    isShowToParticipant,
    setShowToParticipant,
    isReasonTooLong,
    characterLimitText,
    isReasonIncorrect,
  };
};

export default useInvalidationControls;
